// Single source of truth for intranet feature flags. Every flag lives
// here so flipping one at cutover time is a one-line edit with a
// visible blast radius. Importing call-sites stay flag-agnostic — they
// read the constant and branch.
//
// Flip order when the server is ready (details in
// NEEDED_FOR_INTRANET_CLIENT.md):
//
//   1. USE_FINANCIALS_PROJECT   — reads grants from financials project
//   2. USE_MULTITENANT          — scopedClient filters by workspace_id
//   3. DUAL_WRITE_FINANCIALS    — grantsWriter mirrors writes to financials

// Governance reads grants + company_settings from the financials
// Supabase project via finance-features/grants instead of direct
// governance tables. Requires server to emit `orgs[]` in JWT claims
// so financials RLS admin policies pass.
export const USE_FINANCIALS_PROJECT = true

// Every workspace-scoped query filters by root.jwtClaims.active_workspace_id.
// Requires migrations 0045–0050 applied AND server emitting workspaces[]
// in JWT claims. Flip before 0051_multitenancy_rls_swap.sql is applied.
export const USE_MULTITENANT = true

// grantsWriter mirrors every governance grant write to the financials
// project. Governance stays the source of truth; financials is a
// downstream read mirror. Flip after USE_FINANCIALS_PROJECT proves reads
// match for 1+ weeks.
export const DUAL_WRITE_FINANCIALS = true

// `USE_TIER_GATE` was removed — intranet is an org-level feature, not
// tier-level. Anyone in a team org gets full collab access; monetization
// is server-side credit metering per PRICING.md. Scale-only surfaces
// (admin-permissions, admin-logs) call `isScale()` directly without a
// flag gate.

// When true, MemberProfile reads HR fields from `public.profiles`
// (title, timezone, github_username, working hours) and
// mirrors writes to both `user_profiles` and `profiles`. When false,
// only `user_profiles` is touched (legacy). Flip after a validation
// window, then a follow-up migration drops HR columns from
// `user_profiles`.
export const USE_PROFILES_OVERLAY = true

// When true, signed-in users with no team-org memberships see a
// full-viewport onboarding CTA instead of the intranet. Off today
// because governance-bridge login currently returns empty `orgs` for
// every user (the server-side enrichment from NEEDED_FOR_INTRANET.md
// §A hasn't landed). Flip when server emits real `orgs[]` — otherwise
// every real user gets unintentionally blocked.
export const USE_ONBOARDING_GATE = true
